import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from '@app/store/state/app.state';


// The area the box is positioned against, in page coordinates: the hovered week, vertically bounded
// by the row it sits in.
export interface HoverBoxAnchor {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface WallPlannerHoverBoxState {
  isVisible: boolean;
  anchor: HoverBoxAnchor;
  userId?: string;
  fromDate?: string;
}

export const initialWallPlannerHoverBoxState: WallPlannerHoverBoxState = {
  isVisible: false,
  anchor: {top: 0, bottom: 0, left: 0, right: 0},
};

const declineRequest: any = createAsyncThunk(
  'wallPlannerHoverBox/declineRequest',
  async (test: any, thunkAPI) => {
  }
);


const wallPlannerHoverBoxSlice = createSlice({
  name: 'wallPlannerHoverBox',
  initialState: initialWallPlannerHoverBoxState,
  reducers: {
    resetWallPlannerHoverBox: (state) => (initialWallPlannerHoverBoxState),
    setIsVisible: (state, action) => ({ ...state, isVisible: action.payload, }),
    setPositionAndMakeVisible: (state, action) => ({ ...state, anchor: action.payload.anchor, isVisible: true, userId: action.payload.userId, fromDate: action.payload.fromDate }),
  },
  extraReducers: (builder) => {},
});



export default wallPlannerHoverBoxSlice.reducer;
export const { setIsVisible, setPositionAndMakeVisible } = wallPlannerHoverBoxSlice.actions;


// Selectors
export const selectIsBoxVisible = (state: AppState) => state.wallPlannerHoverBox.isVisible;
export const selectAnchor = (state: AppState) => state.wallPlannerHoverBox.anchor;
export const selectRowUserId = (state: AppState) => state.wallPlannerHoverBox.userId;
export const selectRowFromDate = (state: AppState) => state.wallPlannerHoverBox.fromDate;
